module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$parent.form[_vm.$parent.address].invoice_by_post),
      expression: "$parent.form[$parent.address].invoice_by_post"
    }],
    attrs: {
      "name": "postal-delivery",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.$parent.form[_vm.$parent.address].invoice_by_post) ? _vm._i(_vm.$parent.form[_vm.$parent.address].invoice_by_post, null) > -1 : (_vm.$parent.form[_vm.$parent.address].invoice_by_post)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.$parent.form[_vm.$parent.address].invoice_by_post,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.$parent.form[_vm.$parent.address], "invoice_by_post", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.$parent.form[_vm.$parent.address], "invoice_by_post", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.$parent.form[_vm.$parent.address], "invoice_by_post", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "custom-checkbox"
  }), _vm._v("\n        Bitte Rechnung per Post zustellen\n    ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-be08caa2","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./static/js/Order/components/Forms/Fields/InvoicePerPost.vue
// module id = 841
// module chunks = 0